export default __webpack_public_path__ + "static/media/add-plus-green.e1b61781.svg";